function capitalize(str) {
  let words = str.split(" ");
  for (let i = 0; i < words.length; i++) {
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1); 
  }
  let capitalizedStr = words.join(" ");
  return capitalizedStr;
}

class BtnUpload extends HTMLElement {
  constructor() {
    super();
    console.log("%cUPLOADING", "background:green;color:white;padding:10px");

    this.uploadKitEv = new Event('adduploadkit');
    
    this.inputs = {};
    this.type = this.dataset.type;

    this.onWaitUploadKit();

    this.addEventListener('adduploadkit', () => {
      let nameInput = false;
      
      const product = JSON.parse(document.querySelector('#step-block-product').textContent);
      const nameTag = [
        'upload with custom text',
        'upload and text',
        'upload with pets name',
        'upload two pets with name',
        'upload three pets with name',
        'upload four pets with name',
        'upload five pets with name',
        'upload six pets with name',
        'upload with name and location',
      ];

      for (const tag of product.tags) {
        nameInput = nameTag.includes(tag);
        if(nameInput) break;
      }

      if(nameInput) {
        if (this.type === 'ages') {
          this.querySelectorAll('.uploadkit-button').forEach( (btn, arg) => {
            let proName = btn.dataset['uploaderName'];
      
            const label = document.createElement('label');
            let num = arg;
            if(document.querySelectorAll('.uploadkit-button').length > 1) {
              num = arg + 1;
            } else {
              num = '';
            }
    
            const labelName = document.createTextNode(`Age / Caption ${num}`);
            label.appendChild(labelName);
      
            const inputName = document.createElement('input');
            inputName.setAttribute('type', 'text');
            inputName.setAttribute('class', 'pet-name');
            inputName.setAttribute('name', `properties[_${proName}_age]`);
            inputName.setAttribute('placeholder', num === 1 ? 'e.g. Puppy / Kitten / Then / 8 Weeks Old' : 'e.g. Adult / Now / 4 Years Old');
            inputName.setAttribute('value', '');
      
            const pet_name = document.createElement('div');
            pet_name.classList.add('pet_name');
      
            pet_name.appendChild(label);
            pet_name.appendChild(inputName);
      
            btn.after(pet_name);
            let property = JSON.parse( `{"_${proName}\":"","_${proName} (direct link)":"","_${proName}_age":""}`);
            this.inputs.properties = {...this.inputs.properties, ...property};
          });
        } else if (this.type === 'additional text') {
          this.querySelectorAll('.uploadkit-button').forEach( (btn, arg) => {
      
            const label = document.createElement('label');

            let proName = arg === 0 ? 'left' : 'right';
    
            const labelName = document.createTextNode(`${arg === 0 ? 'Left photo name' : 'Right photo name'}`);
            label.appendChild(labelName);
      
            const inputName = document.createElement('input');
            inputName.setAttribute('type', 'text');
            inputName.setAttribute('class', 'pet-name');
            inputName.setAttribute('name', `properties[_${proName}_petName]`);
            inputName.setAttribute('placeholder', 'e.g Tom, Bruno, etc.');
            inputName.setAttribute('value', '');
      
            const pet_name = document.createElement('div');
            pet_name.classList.add('pet_name');
      
            pet_name.appendChild(label);
            pet_name.appendChild(inputName);
      
            btn.after(pet_name);
            let property = JSON.parse( `{"_${proName}\":"","_${proName} (direct link)":"","_${proName}_petName":""}`);
            this.inputs.properties = {...this.inputs.properties, ...property};
          });
        } else {
          this.querySelectorAll('.uploadkit-button').forEach( (btn, arg) => {
            let proName = btn.dataset['uploaderName'];
      
            const label = document.createElement('label');
            let num = arg;
            if(document.querySelectorAll('.uploadkit-button').length > 1) {
              num = arg + 1;
            } else {
              num = '';
            }
    
            const labelName = document.createTextNode(`Pet Name ${num}`);
            label.appendChild(labelName);
      
            const inputName = document.createElement('input');
            inputName.setAttribute('type', 'text');
            inputName.setAttribute('class', 'pet-name');
            inputName.setAttribute('name', `properties[_${proName}_petName]`);
            inputName.setAttribute('placeholder', 'e.g Tom, Bruno, etc.');
            inputName.setAttribute('value', '');
      
            const pet_name = document.createElement('div');
            pet_name.classList.add('pet_name');
      
            pet_name.appendChild(label);
            pet_name.appendChild(inputName);
      
            btn.after(pet_name);
            let property = JSON.parse( `{"_${proName}\":"","_${proName} (direct link)":"","_${proName}_petName":""}`);
            this.inputs.properties = {...this.inputs.properties, ...property};
          });
        }
        if (document.querySelector('#additional-text')) {
          this.inputs.properties = {
            ...this.inputs.properties,
            _additional_text: ""
          };
        }
        if (document.querySelector('#pet-name')) {
          this.inputs.properties = {
            ...this.inputs.properties,
            _pet_name: ""
          };
        }
      }
      console.log(this.inputs);
    });
  }

  onWaitUploadKit() {
    let uploadkit = setInterval(() => {
      if(this.querySelector('.uploadkit-button')) {
        this.dispatchEvent(this.uploadKitEv);
        clearInterval(uploadkit);
      }
    }, 500);
  }

}
customElements.define('upload-btn-wrapper', BtnUpload);

class BtnBefore extends HTMLElement {
  constructor() {
    super();

    this.beforeEv = new Event('before', {bubbles: true});

    this.addEventListener('click', this.onBeforeClick.bind(this));
  }

  onBeforeClick(event) {
    event.preventDefault();
    // debugger;
    this.dispatchEvent(this.beforeEv);
  }
}
customElements.define('before-btn', BtnBefore);

class BtnNext extends HTMLElement {
  constructor() {
    super();

    this.nextEv = new Event('next', {bubbles: true});

    this.addEventListener('click', this.onNextClick.bind(this));
  }

  onNextClick(event) {
    event.preventDefault();
    // debugger;
    this.dispatchEvent(this.nextEv);
  }
}
customElements.define('next-btn', BtnNext);

class OptionItem extends HTMLElement {
  constructor() {
    super();

    this.selectEv = new Event('selectopt', {bubbles: true});

    this.addEventListener('click', this.onSelectOption.bind(this));
  }

  connectedCallback() {
    this.v_option = this.dataset['v_option'];
    this.step = this.dataset['option'];
    let parentEl = document.querySelector(`[data-step="${this.step}"]`) || this.parentElement;
    try {
      const siblings = Array.from(parentEl.querySelectorAll('option-item'))
        .filter(sibling => sibling !== this);
      this.siblings = siblings.length ? siblings : null;
    } catch (err) {
      console.error(`Error selecting siblings: ${err.message}`);
      this.siblings = null;
    }
  }

  onSelectOption() {
    if (!this.siblings) return;
    this.siblings.forEach(sibling => sibling.classList.toggle('selected', false));

    this.classList.toggle('selected', true);
    this.dispatchEvent(this.selectEv);
  }
}
customElements.define('option-item', OptionItem);

class ExtraAdd extends HTMLElement {
  constructor() {
    super();
    this.v_id = this.dataset['v_id'];

    this.addExtraEv = new Event('addextra', {bubbles: true});
    this.removeExtraEv = new Event('removeextra', {bubbles: true});

    this.addEventListener('click', this.updateState.bind(this));
  }

  updateState(ev) {
    ev.preventDefault();

    if(this.classList.contains('added')) {
      this.classList.remove('added');
      this.dispatchEvent(this.removeExtraEv);
    } else {
      this.classList.add('added');
      this.dispatchEvent(this.addExtraEv);
    }
  }
}
customElements.define('extra-add', ExtraAdd); 

class StepBlock extends HTMLElement {
  constructor() {
    super();

    if (!StepBlock._instance) {
      StepBlock._instance = this;
    }
    
    this.steps = [];
    this.url = new URL(window.location.href);
    this.cur_symbol = document.querySelector('#currency_symbol').textContent;
    this.product = JSON.parse(document.querySelector('#step-block-product').textContent);
    this.product.options.forEach(option => {
      this.steps.push(option.toLowerCase());
    });
    let m_product_containers = document.querySelectorAll('.step-block-product_metafields');
    this.m_products = [];
    for (const element of m_product_containers) {
      let m_product = JSON.parse(element.textContent);
      this.m_products.push(m_product);
    }
    
    localStorage.setItem('custom_product', this.product.handle);
    let extra_title = document.querySelector('#step-extras .process-name').textContent;
    localStorage.setItem('extra_title', extra_title);

    localStorage.setItem('m_products', JSON.stringify(this.m_products));

    let curVariantID = this.url.searchParams.get("variant");

    this.cur_variant = curVariantID && this.product.variants.find(variant => variant.id == curVariantID) ? this.product.variants.find(variant => variant.id == curVariantID) : this.product.variants.find(variant => variant.available);

    if (this.cur_variant) {
      this.cur_options = this.cur_variant.options.join();
      let optionNames = this.product.options;
      this.cur_variant.options.forEach( (option, arg) => {
        document.querySelectorAll(`[data-step="${optionNames[arg]}"] option-item`).forEach( item => {
          let v_option = item.dataset['v_option'];
          v_option == option ? item.classList.toggle('selected', true) : null;
        })
      });
      this.dataset['v_id'] = this.cur_variant.id;
      
      this.url.searchParams.set("variant", this.cur_variant.id);
      window.history.replaceState({}, "", this.url);
    }

    this.steps.push('upload', 'extra');

    this.items = [
      {
        id: this.cur_variant.id,
        quantity: 1,
        price: this.cur_variant.price,
        properties: {
          '__step-product': true
        }
      }
    ];
    
    this.addCartEv = new Event('customaddcart', {bubbles: true});

    this.beforeBtn = this.querySelector('before-btn');
    this.nextBtn = this.querySelector('next-btn');
    this.addCartBtn = this.querySelector('.atc-btn');
    this.uploadWrap = this.querySelector('upload-btn-wrapper');
    
    this.setStep(0, false);

    this.addActions();

    this.updateSubTotal();

  }

  addActions() {
    this.addEventListener('selectopt', this.onSelectOption.bind(this));
    this.addEventListener('before', this.onBeforeStep.bind(this));
    this.addEventListener('next', this.onNextStep.bind(this));
    this.addEventListener('addextra', this.onAddExtra.bind(this));
    this.addEventListener('removeextra', this.onRemoveExtra.bind(this));
    this.addEventListener('customaddcart', this.onAddCart);
    this.addCartBtn.addEventListener('click',() => {
      this.dispatchEvent(this.addCartEv);
    });
  }

  onSelectOption(ev) {
    let cur_index = this.dataset.index;
    let value = ev.target.v_option;

    this.updateVariant(cur_index, value);
  }
  
  onBeforeStep(ev) {
    // debugger;
    let index = ev.target.dataset['index'];
    console.log(index);
    index > 0 ? index--: index;
    console.log(index);

    if (this.cur_variant.options[0] == "Digital Download") {
      if (index == 1) {
        this.setStep(0);
      } else {
        this.setStep(index);
      }
    } else {
      this.setStep(index);
    }
  }
  
  onNextStep(ev) {
    let index = ev.target.dataset['index'];
    let current = this.steps[index];

    let limit = this.steps.length;
    limit--;

    index < limit ? index++: index;
    if(current == 'upload') {
      var validated = true;
      var imageAttrContainers = $(this).find('.uploadkit-attribute-container');

      if (window.UploadKit && imageAttrContainers.length > 0 ) {
          for(var i=0; i<imageAttrContainers.length; i++) {
              if(imageAttrContainers[i].innerHTML === '') {
                  validated = false;
              }
          }

      }
      
      if(this.items[0]['properties'] == undefined) {
        Object.assign(this.items[0].properties, { ...this.uploadWrap.inputs.properties });
      }

      this.uploadWrap.querySelectorAll('input').forEach(input => {
        let key = input.name.replace('properties[', '').replace(']','');
        this.items[0]['properties'][key] = input.value;
      });

      console.log( this.items);
      if (validated) {
        this.setStep(index);
      } else {
          $('.mb_container').fadeIn();
          // alert('Please upload image first');
      }
    }
    else {
      if (this.cur_variant.options[0] == "Digital Download") {
        if (index == 1) {
          this.setStep(2);
        } else {
          this.setStep(index);
        }
      } else {
        this.setStep(index);
      }
    }
  }

  setStep(index, scroll=true) {

    this.dataset['index'] = index;
    this.dataset['current'] = this.steps[index];

    let before, next, limit;

    limit = this.steps.length;
    
    index > 0 ? before = this.steps[index - 1] : before = this.steps[0];
    index < --limit ? next = this.steps[index + 1] : next = this.steps[-1];

    this.beforeBtn.dataset['index'] = index;
    this.beforeBtn.dataset['current'] = this.steps[index];
    this.beforeBtn.dataset['before'] = before;
    this.beforeBtn.dataset['next'] = next;

    this.nextBtn.dataset['index'] = index;
    this.nextBtn.dataset['current'] = this.steps[index];
    this.nextBtn.dataset['before'] = before;
    this.nextBtn.dataset['next'] = next;

    this.querySelectorAll('.step-process').forEach( (process, arg) => {
      // debugger;
      if(arg == index) {
        process.classList.remove('active');
        process.classList.add('current');
      } 
      else if(arg < index) {
        process.classList.add('active');
        process.classList.remove('current');
      }
      else {
        process.classList.remove('active');
        process.classList.remove('current');
      }
    });

    if(this.steps[index] != 'upload' && this.steps[index] != 'extra') {
      this.updatePremium(index);
    }

    if(scroll) {
      console.log(window.scrollY - document.querySelector('.headernav').offsetHeight + this.getBoundingClientRect().y);
      if(window.innerWidth < 1024 ) {
        window.scrollTo(0, window.scrollY - document.querySelector('.headernav').offsetHeight + this.getBoundingClientRect().y);
      }
    }
    if(this.steps[index] == 'extra') {
      window.scrollTo(0, window.scrollY - document.querySelector('.headernav').offsetHeight + this.getBoundingClientRect().y);
    }
  }

  updatePremium(index) {
    const curOption = this.cur_variant.options;
    let step = this.steps[index];
    let symbol = this.cur_symbol;
    step = capitalize(step);

    const subVariants = this.product.variants.filter( variant => {
      let isPassed = true;
      let i = 0;

      do {
        if( i != index) {
          variant.options[i] === curOption[i] ? isPassed = true : isPassed = false;
        }
        if(!isPassed) return isPassed;
        i++;
      } while (i < curOption.length);
      return isPassed
    });

    let premiumPrices = {};
    let curPrice = this.cur_variant.price;

    subVariants.forEach( variant => {
      let delta = variant.price - curPrice;
      Object.assign(premiumPrices, {[variant.options[index]]: delta});
    });

    console.log(subVariants, premiumPrices);

    const parent = document.querySelector(`[data-step="${step}"]`);
    parent.querySelectorAll('option-item').forEach( item => {
      let value = item.dataset['v_option'];
      let premiumPrice = premiumPrices[value];
      switch(step) {
        case 'Frame':
        case 'Framing Option':
          premiumPrice > 0 ? item.querySelector('.frame-price').innerHTML = `+${symbol}${premiumPrice/100}` : item.querySelector('.frame-price').innerHTML = '';
          break;
        case 'Size':
          premiumPrice > 0 ? item.querySelector('.size-wrapper').innerHTML = `<div class="add-price">+${symbol}${premiumPrice/100}</div>` : item.querySelector('.size-wrapper').innerHTML = '';
          break;
        case 'Color':
        case 'Tray Color':
        case 'Theme':
          premiumPrice > 0 ? item.querySelector('.bg-wrapper').innerHTML = `<div class="add-price">+${symbol}${premiumPrice/100}</div>` : item.querySelector('.bg-wrapper').innerHTML = '';
          break;
      }
    });
  }

  onAddExtra(ev) {
    let v_id = ev.target.dataset['v_id'];
    let v_price = ev.target.dataset['v_price'];
    let item = {
      id: v_id,
      quantity: 1,
      price: v_price,
    };

    this.items.push(item);

    console.log('%cThis.items', 'background:green;color:white;padding:12px');
    console.log(this.items);

    this.updateSubTotal();
  }

  onRemoveExtra(ev) {
    let v_id = ev.target.v_id;
    console.log(v_id);
    this.items.forEach((item, arg) => {
      if(item.id == v_id) this.items.splice(arg, 1);
    });

    console.log('%cThis.items', 'background:green;color:white;padding:12px');
    console.log(this.items);

    this.updateSubTotal();
  }

  updateVariant(cur_index, value) {
    console.log(`${this.steps[cur_index]}: `, value);

    let cur_options = this.cur_options.split(',');
    let new_options = [...cur_options];
    new_options[cur_index] = value;

    let subVariants = this.product.variants.filter(
      variant => variant.options[cur_index] == value
    );
    for (let i = 0; i < cur_options.length; i++) {
      if (i !== cur_index) {
        const availableCurOptions = [...new Set(subVariants.map(variant => variant.options[i]))];
        const curSubVariants = [...subVariants.filter(
          variant => variant.options[i] == cur_options[i]
        )];

        if (!curSubVariants.length) {
          new_options[i] = availableCurOptions.pop();
          subVariants = [...subVariants.filter(
            variant => variant.options[i] == new_options[i]
          )];
          document.querySelectorAll(`[data-step="${capitalize(this.steps[i])}"] option-item`).forEach(option => {
            if (option.dataset['v_option'] == new_options[i]) {
              option.classList.add("selected");
            } else {
              option.classList.remove("selected");
            }
          });
        } else {
          subVariants = [...curSubVariants];
        }
      }
    }
    this.cur_variant = subVariants.pop();
    this.cur_options = new_options.join();

    this.url.searchParams.set("variant", this.cur_variant.id);
    window.history.replaceState({}, "", this.url);

    this.items[0].id = this.cur_variant.id;
    this.items[0].price = this.cur_variant.price;
    
    Object.assign(this.items[0].properties, { ...this.uploadWrap.inputs.properties });

    this.updateSubTotal();

    if(this.cur_variant.featured_media) {

      let v_img = this.cur_variant.featured_media.id;
      let slidedImage = false;
  
      document.querySelectorAll('.mySwiper2 .swiper-slide img').forEach( (img, arg) => {
        if(img.dataset['id'] == v_img && slidedImage != true) {
          slidedImage = true;
          window.mySwiper.slideTo(arg);
        }
      });
    }

    this.updatePremium(cur_index);

    if (this.cur_variant.options[0] == "Digital Download") {
      document.querySelector('.extra-variant[data-v_id="29877512667222"]')?.classList?.add("hidden");
    } else {
      document.querySelector('.extra-variant[data-v_id="29877512667222"]')?.classList?.remove("hidden");
    }
    
  }

  onAddCart() { 
    const items = this.items;
    var free_mug_index = -1;
    for (let index = 0; index < items.length; index++) {
      var item = items[index];
      if (item.properties != undefined) {
        if (item?.properties['__free-mug']){
          free_mug_index = index;
        }
      }
    }
    console.log("free mug index", free_mug_index);
    if (free_mug_index > 0){
      items.splice(free_mug_index, 1);
    }
    
    const sections = 'cart-drawer';

    let product_info = JSON.parse(document.querySelector('#step-block-product').textContent);
    let mug_vt_id = document.querySelector("step-block").getAttribute("mug-v_id");
    let main_item = this.items[0];
    let main_prop = main_item["properties"];
    main_prop["__time"] = Date.now();
    let mug_prop = JSON.stringify(main_prop);
    mug_prop = JSON.parse(mug_prop);
    delete mug_prop["__step-product"];
    mug_prop["__free-mug"] = "true";
    let mug = {
      id: mug_vt_id,
      quantity: 1,
      price: 0,
      properties: mug_prop
    };
    
    let true_mug = false;
    for (let i = 0; i < product_info.variants.length; i++) {
      if (product_info.variants[i].id == main_item.id) {
        let main_variant = product_info.variants[i];
        if (main_variant.option2 != "Unframed") {
          true_mug = true;
        }
      }
    }

    if (true_mug && mug_vt_id != "") {
      items.push(mug);
    }

    document.querySelector('.atc-btn').classList.toggle("loading", true);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            items,
            sections
        })
    })
    .then(res => res.json())
    .then(res => {
        console.log(res);
        let step_header = document.querySelector('.step-header-wrapper').outerHTML;
        let step_header_style = document.querySelector('#step-header-style').outerHTML;
        localStorage.setItem('step_header', step_header);
        localStorage.setItem('step_header_style', step_header_style);
        document.querySelector('.atc-btn').classList.toggle("loading", true);
        switch(window.cta_target) {
          case 'bundle':
            window.location.href = window.location.origin + '/pages/bundle-and-save';
            break;
          case 'checkout':
            window.location.href = window.location.origin + '/checkout';
            break;
          case 'cart':
            window.location.href = window.location.origin + '/cart';
            break;
          default:
            reBuildCart();
            open_cart_drawer();
            document.querySelector('.atc-btn').classList.toggle("loading", false);
        }
    })
    .catch(err => console.log(err));

  }

  updateSubTotal() {
    let subTotal = 0;
    let symbol = this.cur_symbol;
    let rate = parseFloat(window.Shopify.currency.rate);
    let variantId;

    for (const item of this.items) {
      subTotal += parseInt(item.price);
      variantId = item.id;
    }

    try {
      this.querySelector('.subtotal .money').setAttribute('data-variant-id',variantId);
      this.querySelector('.subtotal .money').innerHTML = `${symbol}${(subTotal / 100 ).toFixed(2)}`;
      if( subTotal < 10000) {
        this.querySelector('.step-freeshipping').innerHTML = `<p>You're only <span class="money">${symbol}${((10000 - subTotal)/100).toFixed(2)}</span> away from <strong>FREE SHIPPING</strong></p>`;
      } else {
        this.querySelector('.step-freeshipping').innerHTML = "<p>Congrats! You've earned <strong>FREE SHIPPING</strong></p>";
      }
    } catch (error) {
      console.error(error);
    }
  }
}

customElements.define('step-block', StepBlock);

class VariantOption extends HTMLElement {
  constructor() {
    super();
    this.updateOtionEv = new Event('option:change', {bubbles: true});

    this.addEventListener('click', () => {
      this.parentElement.querySelectorAll('variant-option').forEach(sibling => sibling.classList.toggle('selected', false));
      this.classList.toggle('selected', true);
      this.dispatchEvent(this.updateOtionEv);
    });
  }

}

customElements.define('variant-option', VariantOption);

class OptionContainer extends HTMLElement {
  constructor() {
    super();
    let target = this.dataset.option;
    this.targetEl = document.querySelector(`.design-option[data-option="${target}"]`);
    this.opener = this.targetEl.querySelector('.option-choose').parentElement;
    this.closer = document.querySelector('option-drawer .before-step');
    this.parent = this.parentElement;
    this.addActions();
  }

  init() {
    this.selectedEl = this.querySelector('variant-option.selected');
    let detailEl = this.selectedEl?.querySelector('[data-option-detail]'); 
    let imageEl = this.selectedEl?.querySelector('img'); 
  
    this.curOption = {
      title: this.selectedEl.dataset.optionValue,
      detail: detailEl?.innerHTML,
      image: imageEl?.src
    };
  }

  addActions() {
    this.addEventListener('option:change', this.updateCurOption.bind(this));
    this.opener.addEventListener('click', () => {
      this.open();
    });
    this.closer.addEventListener('click', () => {
      this.close();
    });
  }

  updateCurOption(ev) {
    this.curOption.title = ev.target.dataset.optionValue;

    ev.target.querySelector('[data-detail]') ? this.curOption.detail = ev.target.querySelector('[data-detail]').innerHTML : null;

    ev.target.querySelector('img') ? this.curOption.image = ev.target.querySelector('img').src : null;
  }

  updateUi() {
    console.log(this.curOption);
    this.curOption?.title ? this.targetEl.querySelector('.option-title').innerHTML = this.curOption.title : null;
    this.curOption?.detail ? this.targetEl.querySelector('.option-detail').innerHTML = this.curOption.detail : null;
    this.curOption?.image ? this.targetEl.querySelector('.option-image').querySelector('img').setAttribute("src", this.curOption.image) : null;
  }

  open() {
    let target = this.dataset.option;
    this.init();
    this.updateUi();
    this.parentElement.scrollTop = 0;
    let optionName = this.dataset.optionName;
    window.productData.options.forEach((option, arg) => {
      if(option == optionName) {
        document.querySelector('option-drawer').updatePremium(arg);
      }
    });
    this.parent.dataset.option = target;
    document.querySelector('option-drawer').dataset.option = target;
  }
  
  close() {
    this.init();
    this.updateUi();
    this.parent.dataset.option = 'frame';
    document.querySelector('option-drawer').dataset.option = 'frame';
  }
}

customElements.define('option-container', OptionContainer);

class SummaryDesign extends HTMLElement {
  constructor() {
    super();
    this.product = window.productData;
    this.cur_symbol = document.querySelector('#currency_symbol').textContent;
  }

  init() {
    let cur_symbol = this.cur_symbol;
    
    document.querySelector('option-drawer .summary-count .count').innerHTML = ms_num;
    this.querySelector('.summary-delete').classList.toggle('hidden', ms_num == 1);
    document.querySelectorAll('ms-catalog').forEach((catalog, arg) => {
      const target = this.querySelector(`.summary-item:nth-child(${arg + 2})`);
      if (catalog.className.includes('active')) {
        target.classList.toggle('active', true);
        let v_id = catalog.vt_id;
        const curVaraint = this.product.variants.find( variant => variant.id == v_id);

        target.querySelector('.summary-media').style.backgroundImage = `url(${catalog.upload_prop_direct_val})`;
        target.querySelector('.summary-title').innerHTML = this.product.title;
        for (let i = 0; i < this.product.options.length; i++) {
          target.querySelector(`.summary-option[data-option="${this.product.options[i]}"] .option-value`).innerHTML = curVaraint.options[i];
        }
        target.querySelector('.summary-price'). innerHTML = `${cur_symbol}${(curVaraint.price / 100).toFixed(2)}`;
        target.querySelector('.summary-edit').addEventListener('click', () => {
          if(catalog.className.includes('uploaded')) {
            catalog.querySelector('.edit-btn').dispatchEvent(new MouseEvent('click'));
          } else {
            document.querySelector('option-drawer').close();
            catalog.querySelector('.ms-photo-wrapper').dispatchEvent(new MouseEvent('click'));
            
          }
        });
        target.querySelector('.summary-delete').addEventListener('click', () => {
          let parent = target.parentElement;
          const index = Array.prototype.indexOf.call(parent.children, target);
          document.querySelector('.remove-modal').dataset.index = index;
          document.querySelector('.remove-modal').classList.remove('hidden');
        });
      }
      else {
        target.classList.toggle('active', false);
      }
    });
  }
}

customElements.define('summary-design', SummaryDesign);
class OptionDrawer extends HTMLElement {
  constructor() {
    super();
    this.product = window.productData;
    this.curVaraint = '';
    this.vt_id = '';
    this.price = '';
    this.curOption = '';
    this.target = '';
    this.cur_symbol = document.querySelector('#currency_symbol').textContent;
    this.applyer = this.querySelector('.apply-design');
    this.closer = this.querySelector('.drawer__close');
    this.atc = this.querySelector('.proceed-checkout a');
    this.addActions();
  }

  addActions() {
    this.closer.addEventListener('click', () => {
      this.close();
    });

    this.addEventListener('click', (e) => {
      const overlayClicked = this.querySelector('.design-container').contains(e.target);
      overlayClicked ? null : this.close();
    });

    this.addEventListener('option:change', this.updateVariant.bind(this));

    this.applyer.addEventListener('click', () => {
      this.applyDesign();
    });
    this.atc.addEventListener('click', (ev) => {
      ev.preventDefault();
      const items = this.items;
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            items
        })
      })
      .then(res => res.json())
      .then(res => {
        console.log(res);
        window.location.href = '/checkout';
      });
    });
  }

  updateOptions() {
    const curOption = this.curOption.split(',');
    this.querySelectorAll('variant-option').forEach(option => {
      if(curOption.includes(option.dataset.optionValue)) {
        option.classList.toggle('selected', true);
      } else {
        option.classList.toggle('selected', false);
      }
    });
    this.querySelectorAll('option-container').forEach(container => {
      container.init();
      container.updateUi();
    });
  }

  updateVariant(ev) {
    let optionName = ev.target.dataset.optionName;
    let optionValue = ev.target.dataset.optionValue;
    this.product.options.forEach((option, arg) => {
      if(option == optionName) {
        let curOption = this.curOption.split(',');
        curOption[arg] = optionValue;
        this.curOption = curOption.join(',');

        const curVaraint = this.product.variants.find(variant => {
          return variant.options.join(',') == curOption.join(',');
        });
        this.vt_id = curVaraint.id;
        this.price = curVaraint.price;
        this.updatePremium(arg);
        this.target.price = this.price;
        this.target.vt_id = this.vt_id;
        this.target.classList.add('designed');
        this.updateSubTotal();
      }
    });

    console.log(this.vt_id);
  }

  updatePremium(index) {
    let cur_symbol = this.cur_symbol;
    let curOption = this.curOption.split(',');
    const subVariants = this.product.variants.filter( variant => {
      let isPassed = true;
      let i = 0;

      do {
        if( i != index) {
          variant.options[i] === curOption[i] ? isPassed = true : isPassed = false;
        }
        if(!isPassed) return isPassed;
        i++;
      } while (i < curOption.length);
      return isPassed
    });

    let premiumPrices = {};
    let curPrice = this.price;

    subVariants.forEach( variant => {
      let delta = variant.price - curPrice;
      Object.assign(premiumPrices, {[variant.options[index]]: delta});
    });
    let target = this.product.options[index].toLowerCase();
    console.log(subVariants);
    console.log(premiumPrices);
  
    for (const key in premiumPrices) {
      premiumPrices[key] > 0 ? this.querySelector(`variant-option[data-option-value='${key}'] .premium-price`).innerHTML = `+${cur_symbol}${(premiumPrices[key] / 100).toFixed(2)}` : this.querySelector(`variant-option[data-option-value='${key}'] .premium-price`).innerHTML = null;
    }
  }

  updateSubTotal() {
    let subTotal = count_subtotal_price();
    let originalTotal = count_original_price ();
    let saveTotal = count_saving_price();
    try {
      this.querySelector('.design-header .summary-price').innerHTML = `${this.cur_symbol}${subTotal.toFixed(2)}`;
      this.querySelector('.design-footer .summary-price').innerHTML = `${this.cur_symbol}${subTotal.toFixed(2)}`;
      this.querySelector('.total-price').innerHTML = `${this.cur_symbol}${originalTotal.toFixed(2)}`;
      let reward = '';
      this.querySelector('#reward-content span[data-free-shipping]').classList.toggle('hidden', subTotal < 100);
  
      reward = `You're Saving ${this.cur_symbol}${(saveTotal).toFixed(2)}`;
      this.querySelector('#reward-content span[data-saving]').innerHTML = reward;
    } catch (error) {
      console.error(error);
    }
  }
  applyDesign() {
    this.target.price = this.price;
    this.target.vt_id = this.vt_id;
    this.target.classList.add('designed');
    update_designed_num();
    if(this.dataset.option == 'frame') {
      this.close();
    } 
    else {
      this.querySelectorAll('option-container').forEach(container => {
        container.close();
      });
    }
    update_subtotal();
  }

  open(el, step='frame', items=null) {
    el ? null : el = document.querySelector('ms-catalog.active');
    const parent = document.querySelector('.ms-catalog-wrapper');
    const index = Array.prototype.indexOf.call(parent.children, el);
    const total = document.querySelectorAll('ms-catalog.active').length;
    document.querySelector('option-drawer .edit-tile').innerHTML = `${index + 1} / ${total}`;
    
    if(step == 'summary') {
      this.items = items;
      document.querySelector('summary-design').init();
      this.querySelector('.design-body').scrollTop = 0;
    } 
    this.dataset.option = step;
    this.target = el;
    this.vt_id = el.vt_id;
    this.price = el.price;
    let imgUrl = el.upload_prop_direct_val;
    this.querySelector('.design-preview .image-wrapper').style.backgroundImage = `url(${imgUrl})`;

    this.product.variants.forEach( variant => {
      if(variant.id == this.vt_id) {
        let options = variant.options;
        this.curOption = options.join(',');
      }
    });
    this.updateOptions();
    this.updateSubTotal();
    this.classList.toggle('open', true);
    document.querySelector('body').classList.toggle('option-drawer', true);
  }

  close() {
    this.dataset.option = 'frame';
    this.classList.toggle('open', false);
    document.querySelector('body').classList.toggle('option-drawer', false);
  }
}

customElements.define('option-drawer', OptionDrawer);